/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {ReferenceDataPageComponent} from './reference-data-page.component';
import {NetworkResource} from '../../../components/api/resources/resource/network.resource.token';
import {NetworkProfileResource} from '../../../components/api/resources/resource/network-profile.resource.token';



export function referenceDataStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.adm.reference-data', {
          url: '/reference-data',
          resolve: {
            ResourceFactory: function() {
              return adnRouterHelper.services.resource(NetworkResource);
            },
            network: function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return adnRouterHelper.services.resource(NetworkResource).get({id: LocalNetworkProfile.getNetworkId()}).$promise;
            },
            networkProfile: function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return adnRouterHelper.services.resource(NetworkProfileResource).get({id: LocalNetworkProfile.getNetworkId()}).$promise;
            }
          },
          views: {
            'content@app': {
              component: ReferenceDataPageComponent
            },
            'title@app': stateTitleView()
          },
          data: {
            title: "Reference Data"
          }
        });
  }, adnRouterHelper);
}
